import { render, staticRenderFns } from "./TransferTable.vue?vue&type=template&id=1d463d1b&"
import script from "./TransferTable.vue?vue&type=script&lang=ts&"
export * from "./TransferTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d463d1b')) {
      api.createRecord('1d463d1b', component.options)
    } else {
      api.reload('1d463d1b', component.options)
    }
    module.hot.accept("./TransferTable.vue?vue&type=template&id=1d463d1b&", function () {
      api.rerender('1d463d1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/TransferTable.vue"
export default component.exports